import React from "react";
import HomePageStore from "../HomePageStore";
import { observer, inject } from "mobx-react";

interface SubaruDifferenceProps {}

interface InjectedProps extends SubaruDifferenceProps {
  homePageStore: HomePageStore;
}
const subaruDifference: React.SFC<SubaruDifferenceProps> = (props) => {
  const { homePageStore } = props as InjectedProps;
  const { subaruDifference } = homePageStore.homePageContent.response;
  return (
    <section className="pageHero subaru_differance_wrapper">
      <div
        className="fullBgImage hidden-lg hidden-sm hidden-md"
        style={{ backgroundImage: "url(" + subaruDifference.xsImageUrl + ")" }}
      >
      </div>

      <div
        className="fullBgImage hidden-lg hidden-xs hidden-md"
        style={{ backgroundImage: "url(" + subaruDifference.smImageUrl + ")" }}
      >
      </div>

      <div
        className="fullBgImage hidden-lg hidden-xs hidden-sm"
        style={{ backgroundImage: "url(" + subaruDifference.lgImageUrl + ")" }}
      >
      </div>

      <div
        className="fullBgImage hidden-md hidden-sm hidden-xs"
        style={{ backgroundImage: "url(" + subaruDifference.xlImageUrl + ")" }}
      >
      </div>

      <div className=" pageHero__content container">
        <div className="subaru_title_cta">
          <h2
            dangerouslySetInnerHTML={{
              __html: subaruDifference.ctaTitle,
            }}
          />
          {subaruDifference.linkTitle !== "" && (
            <div className="cta-wrapper">
              <a href={subaruDifference.link} className="btn">
                {subaruDifference.linkTitle}
              </a>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default inject("homePageStore")(observer(subaruDifference));
